import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { GymEquipment } from "@/features/gyms";

/** GYM AND EQUIPMENT — the second tab. Handoff Screen 7. */
export const Route = createFileRoute("/_app/gym")({
  component: GymScreen,
});

function GymScreen() {
  const { t } = useTranslation("gyms");

  return (
    <div className="flex flex-col gap-6">
      <header className="flex flex-col gap-0.5">
        <h1 className="text-title">{t("title")}</h1>
        <p className="text-support text-muted-foreground">{t("subtitle")}</p>
      </header>
      <GymEquipment />
    </div>
  );
}
